import { List, Map } from "immutable";

import { composeSelectors } from "seneca-common/utils/selectors/compose-selectors";

import { SectionStat } from "../../../../models/state/sectionStats";
import * as statSelectors from "./stat";
import { SectionStats, SectionStatSelectors } from "./types";

type SectionId = string;

export const getSectionStat = (
  sectionStats: SectionStats,
  sectionId: SectionId
): SectionStat | null | undefined => sectionStats.get(sectionId);

export function getSectionsStats(
  sectionStats: SectionStats,
  sectionIds: List<SectionId>
): SectionStats {
  // @ts-ignore
  return sectionIds.reduce((acc: any, sectionId: string) => {
    const sectionStat = getSectionStat(sectionStats, sectionId);
    return sectionStat ? acc.set(sectionId, sectionStat) : acc;
  }, Map());
}

// @ts-ignore
export const {
  getTimesStudied,
  getTotalStudyTime,
  getBestScore,
  getLastScore,
  getSpacing,
  getLastStudied,
  getSectionId,
  getAverageScore,
  getModuleIdsIncorrectLast
}: SectionStatSelectors<SectionStats> = composeSelectors(
  getSectionStat,
  statSelectors
);

export function hasSectionStat(
  sectionStats: SectionStats,
  sectionId: SectionId
) {
  return sectionStats && sectionStats.has(sectionId);
}

export function getNumberOfModuleIdsIncorrect(
  sectionStats: SectionStats,
  sectionId: SectionId
) {
  const moduleIdsIncorrectLast = getModuleIdsIncorrectLast(
    sectionStats,
    sectionId
  );

  return moduleIdsIncorrectLast ? moduleIdsIncorrectLast.size : 0;
}
